// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__1CSV3","buttons":"RemoveExpirationActionButtons_buttons__35Nio"};